import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { boldGreen } from '@render-mark/bold-green'
import { italicImageText } from '@render-mark/italic-image-text'
import { documentCentered } from '@render-node/document-centered'
import { documentHeading3 } from '@render-node/document-heading-3'
import { heading3GreenSpan } from '@render-node/heading-3-green-span'
import { heading3GreenSpanInherit } from '@render-node/heading-3-green-span-inherit'
import { paragraphNoGutter } from '@render-node/paragraph-no-gutter'
import { children } from '@render-node/utils/children'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { type RichTextOptions } from '@resolvers/rich-text/types'

export const contentArticleTitleOptions: RichTextOptions = {
  ...defaultRichTextFieldOptionsDeprecated,
  renderNode: {
    ...defaultRichTextFieldOptionsDeprecated.renderNode,
    [BLOCKS.DOCUMENT]: documentHeading3,
    [BLOCKS.HEADING_3]: heading3GreenSpanInherit,
    [BLOCKS.PARAGRAPH]: children,
  },
}

export const contentArticleImageTextOptions: RichTextOptions = {
  ...defaultRichTextFieldOptionsDeprecated,
  renderMark: {
    ...defaultRichTextFieldOptionsDeprecated.renderMark,
    [MARKS.BOLD]: boldGreen,
    [MARKS.ITALIC]: italicImageText,
  },
  renderNode: {
    ...defaultRichTextFieldOptionsDeprecated.renderNode,
    [BLOCKS.DOCUMENT]: documentCentered,
    [BLOCKS.HEADING_3]: heading3GreenSpan,
    [BLOCKS.PARAGRAPH]: paragraphNoGutter,
  },
}
